<template>
  <b-container fluid>
    <b-row v-if="settings">
      <b-col xl="9">
        <ProductConfigurator :key="componentKey" />
      </b-col>

      <b-col xl="3">
        <ConfigurationSummary />
      </b-col>
    </b-row>
    <div v-else-if="fetchSettingsError">
      <Error v-bind:errorMessage="fetchSettingsError" />
    </div>
  </b-container>
</template>

<script>
import ProductConfigurator from "../components/configurator/ProductConfigurator";
import ConfigurationSummary from "../components/configurator/ConfigurationSummary";
import Error from "../components/shared/Error";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Shop",
  components: {
    ProductConfigurator,
    ConfigurationSummary,
    Error,
  },

  data() {
    return {
      componentKey: 0,
    };
  },

  computed: {
    ...mapGetters(["settings", "fetchSettingsError"]),
  },

  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
  },
};
</script>

